module.exports = __webpack_public_path__ + "static/media/organization--en.3cbc0ffa.png";